/* eslint-disable no-console */
import { get, isEmpty } from 'lodash';

import GearzettePageQuery from 'Query/GearzettePage.query';
import { setLoading, updateGearzettePageRecentsPost } from 'Store/GearzettePage';
import { updateNoMatch } from 'Store/NoMatch/NoMatch.action';
import { QueryDispatcher } from 'Util/Request';

/** @namespace Pwa/Store/GearzettePage/RecentsPost/Dispatcher/RecentsPostDispatcher */
export class RecentsPostDispatcher extends QueryDispatcher {
    __construct() {
        super.__construct();
    }

    // eslint-disable-next-line no-unused-vars
    onSuccess(response, dispatch, { cb }) {
        const recentsPost = get(response, 'posts', []);
        if (!isEmpty(recentsPost)) {
            dispatch(updateGearzettePageRecentsPost(recentsPost, false));
        }
    }

    onError(_, dispatch) {
        dispatch(setLoading(false));
        dispatch(updateNoMatch(true));
    }

    prepareRequest(options, dispatch) {
        dispatch(setLoading(true));
        return GearzettePageQuery.getRecentsQuery(options);
    }
}

export default new RecentsPostDispatcher();
